module.exports = __webpack_public_path__ + "h5/img/grade.75b86c1a.png";